import { createSelector } from 'reselect'

export const selectSite = (state) => state.site
export const selectSiteName = (state) => state.site.name
export const selectSiteKey = (state) => state.site.key
export const selectSiteSlug = (state) => state.site.slug
export const selectSiteAbbr = (state) => state.site.abbr
export const selectSiteUaStoreSlug = (state) => state.site.uaStoreSlug
export const selectSiteActivityTypeId = (state) => state.site.activityTypeID
export const selectSiteAuthUrl = createSelector(
  selectSite,
  (site) => `${site.canonical}auth/login`
)

export const selectDev = createSelector(
  selectSiteKey,
  (key) => {
    const local = process.env.NODE_ENV === 'development'
    const devint = key === 'devint'
    return local || devint
  }
)

export const selectAccountDeleteViewRedirectURI = createSelector(
  selectDev,
  (dev) => {
    const siteURL = dev ? 'devint.mapmyfitness.com' : 'www.mapmyfitness.com'
    return `http://${siteURL}/redirect/device/?desktop=http://${siteURL}/auth/login&ios=mmapps://delete_user/&android=mmapps://delete_user/`
  }
)
